import React from "react";
// import "./ShoeLoader.css";

const ShoeLoader = ({ width = 160, height = 85, text = true }) => {
	return (
		<span style={{ textAlign: "center", margin: "0" }}>
			{text && <p>Betöltés folyamatban ...</p>}
			<img
				// src="/images/shoe_loader_transparent_black.gif"
				src="/images/elitcipo_loader_crop.gif"
				alt="Dolgozom ..."
				style={{ width: width + "px", height: height + "px" }}
			/>
		</span>
	);
};

export default ShoeLoader;
